<template>
  <div class="footer-wrapper mx-8">
    <div class="grid grid-cols-12 h-full items-end">
      <div class="col-span-12 lg:col-span-12 xl:col-span-9 flex items-center flex-wrap justify-between pills-wrapper">
        <SmallFacePills type="good" />
        <SmallFacePills type="moderate" />
        <SmallFacePills type="inadequate" />
        <SmallFacePills type="bad" />
        <SmallFacePills type="veryBad" /> 
      </div>
      <div class="col-span-12 xl:col-span-3 lg:col-span-12">
        <DateTimeDisplay />
      </div>
    </div>

  </div>
</template>

<script>
import SmallFacePills from '@/components/generic/SmallFacePills.vue'
import DateTimeDisplay from '@/components/generic/DateTimeDisplay.vue'

export default {
  components: {
    SmallFacePills,
    DateTimeDisplay
  }
}
</script>

<style lang="scss">
  .footer-wrapper{
    .pills-wrapper{
      max-width: 1000px;
    }
  }

 //lg
@media (max-width: 1279.98px) { 
  .footer-wrapper{
    .pills-wrapper{
      max-width: none !important;
      margin: 0px 0 30px;
      justify-content: center;
      .face-pills-wrapper{
        margin: 10px 10px;
      }
    }
  }
}
</style>